import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export default function useQuestionnairePath(basePath: string, idParamName: string): string {
  const params = useParams();
  const questionnaireId = params[idParamName];

  return useMemo(
    () => (questionnaireId ? `${basePath}/${questionnaireId}` : basePath),
    [basePath, questionnaireId],
  );
}
